import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { AppConstants } from 'src/environments/constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-tabs',
  templateUrl: './dashboard-tabs.component.html',
  styleUrls: ['./dashboard-tabs.component.scss'],
})
export class DashboardTabsComponent {
  selectedTab = 1;
  notificheOrdini = 0;
  notificheSvincoli = 0;
  notificheNonConformita = 0;

  @Input() isTeamView: boolean;

  constructor(
    private dashServ: DashboardService,
    private router: Router
  ) {}

  async getNumeroNotificheOrdini() {
    this.notificheOrdini = await this.dashServ.getNumeroNotificheOrdini();
  }

  async getNumeroNotificheSvincoli() {
    this.notificheSvincoli = await this.dashServ.getNumeroNotificheSvincoli();
  }

  async getNumeroNotificheNonConformita() {
    this.notificheNonConformita =
      await this.dashServ.getNumeroNotificheNonConformita();
  }

  onClickOrdini() {
    this.selectedTab = 1;
  }

  onClickSvincoli() {
    this.selectedTab = 2;
  }

  onClickNonConformita() {
    this.selectedTab = 3;
  }

  vaiAgliOrdini() {
    this.router.navigate([AppConstants.ORDINI_ROUTE]);
  }

  vaiAgliSvincoli() {
    this.router.navigate([AppConstants.SVINCOLI_ROUTE]);
  }

  vaiAlleNonConformita() {
    this.router.navigate([AppConstants.NONCONFORMITA_ROUTE]);
  }
}
